import React, {Component} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import Login from "./containers/main/Login";
import Error404 from "./containers/Error404";
import IndexSetup from "./containers/setup/IndexSetup";
import DashboardLayout from "./containers/DashboardLayout";
import AccountSetup from "./containers/setup/AccountSetup";
import Register from "./containers/main/Register";
import ResetPassword from "./containers/main/ResetPassword";
import ResetPasswordConfirm from "./containers/main/ResetPasswordConfirm";
import localDB from "./data/localDB";

const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => (
        localDB.getAuthToken() ? (
            <Component {...props}/>
        ) : (
            <Redirect to={{
                pathname: '/login',
                state: {from: props.location}
            }}/>
        )
    )}/>
);

class RouteRoot extends Component {
    render() {
        return (
            <Switch>
                <Route path="/activation/:session" component={IndexSetup}/>
                <Route exact path="/account_setup" component={AccountSetup}/>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/register" component={Register}/>
                <Route exact path="/reset" component={ResetPassword}/>
                <Route path="/reset/:uid/:token" component={ResetPasswordConfirm}/>
                <PrivateRoute path="/" component={DashboardLayout}/>
                <Route path="*" component={Error404}/>
            </Switch>
        );
    }
}
export default RouteRoot;



// WEBPACK FOOTER //
// ./src/RouteRoot.js